import { scheduleTabs } from './constants';
import type { ScheduleTab, ViewMode } from './types';

type SessionsToolbarProps = {
  data: {
    activeTab: ScheduleTab;
    viewMode: ViewMode;
  };
  actions: {
    onTabChange: (tab: ScheduleTab) => void;
    onToggleSchedule: () => void;
    onViewModeChange: (mode: ViewMode) => void;
  };
};

const SessionsToolbar = ({ data, actions }: SessionsToolbarProps) => (
  <div className="flex flex-wrap items-center justify-between gap-3">
    <div className="flex flex-wrap items-center gap-2">
      {scheduleTabs.map((tab) => (
        <button
          key={tab}
          type="button"
          onClick={() => actions.onTabChange(tab)}
          className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
            data.activeTab === tab
              ? 'bg-slate-100 text-slate-900'
              : 'text-slate-500 hover:text-slate-700'
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
    {data.activeTab !== 'Recordings' && (
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="flex items-center gap-2 rounded-[10px] bg-slate-900 px-4 py-2 text-sm font-semibold text-white"
          onClick={actions.onToggleSchedule}
        >
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M8 2v4M16 2v4" />
            <rect x="3" y="4" width="18" height="18" rx="2" />
            <path d="M3 10h18" />
            <path d="M8 14h8" />
          </svg>
          Schedule Session
        </button>
        <button
          type="button"
          onClick={() => actions.onViewModeChange('list')}
          className={`flex h-9 w-9 items-center justify-center rounded-lg border border-slate-100 transition ${
            data.viewMode === 'list'
              ? 'bg-white text-slate-900 shadow-sm'
              : 'bg-slate-50 text-slate-600'
          }`}
          aria-label="List view"
        >
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M8 6h13M8 12h13M8 18h13" />
            <circle cx="4" cy="6" r="1" />
            <circle cx="4" cy="12" r="1" />
            <circle cx="4" cy="18" r="1" />
          </svg>
        </button>
        <button
          type="button"
          onClick={() => actions.onViewModeChange('calendar')}
          className={`flex h-9 w-9 items-center justify-center rounded-lg border border-slate-100 transition ${
            data.viewMode === 'calendar'
              ? 'bg-white text-slate-900 shadow-sm'
              : 'bg-slate-50 text-slate-600'
          }`}
          aria-label="Calendar view"
        >
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M8 2v4M16 2v4" />
            <rect x="3" y="4" width="18" height="18" rx="2" />
            <path d="M3 10h18" />
          </svg>
        </button>
      </div>
    )}
  </div>
);

export default SessionsToolbar;
